const IMAGE_TAG_PATTERN = /<img\b[^>]*>/gi;
const ALT_ATTRIBUTE_PATTERN = /\balt\s*=\s*(["'])(.*?)\1/i;

const normalizeBaseUrl = (value) => String(value || '').replace(/\/+$/, '');

const toPositiveInteger = (value) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export function buildPublicFileUrl(baseUrl, s3Key) {
  const normalizedKey = String(s3Key || '').replace(/^\/+/, '');
  if (!normalizedKey) return '';
  return `${normalizeBaseUrl(baseUrl)}/${normalizedKey}`;
}

export function buildUploadedImagePresentation(result, filesUrl) {
  const variants = (Array.isArray(result?.fileData) ? result.fileData : [])
    .map((variant) => ({
      s3Key: variant?.s3Key,
      width: toPositiveInteger(variant?.width),
      height: toPositiveInteger(variant?.height),
    }))
    .filter((variant) => variant.s3Key && variant.width && variant.height)
    .sort((left, right) => left.width - right.width);

  const largestVariant = variants.at(-1);
  const fallbackKey = largestVariant?.s3Key || result?.s3Key;
  const src = buildPublicFileUrl(filesUrl, fallbackKey);

  if (!src) {
    throw new Error('ERR_EDITOR_IMAGE_URL');
  }

  return {
    src,
    srcset: variants
      .map((variant) => `${buildPublicFileUrl(filesUrl, variant.s3Key)} ${variant.width}w`)
      .join(', '),
    sizes: '(max-width: 768px) calc(100vw - 32px), 1120px',
    width: largestVariant?.width || null,
    height: largestVariant?.height || null,
  };
}

export function validatePublicationHtml(html) {
  const imageTags = String(html || '').match(IMAGE_TAG_PATTERN) || [];
  const imagesWithoutAlt = imageTags.filter((tag) => {
    const match = tag.match(ALT_ATTRIBUTE_PATTERN);
    return !match || !match[2].trim();
  }).length;

  if (imagesWithoutAlt > 0) {
    return {
      valid: false,
      imagesWithoutAlt,
      message: imagesWithoutAlt === 1
        ? 'Добавьте описание ALT для изображения.'
        : `Добавьте описание ALT для изображений: ${imagesWithoutAlt}.`,
    };
  }

  return { valid: true, imagesWithoutAlt: 0, message: '' };
}
